import { makeStyles } from "@material-ui/core/styles";

export const useAchievementsStyles = makeStyles(theme => ({
  container: {
    padding: "0",
    marginTop: 24,
    backgroundColor: "transparent",
    color: "#FFFFFF",
    maxWidth: "780px",
    marginLeft: 0,
    marginRight: "auto",
    [theme.breakpoints.up("md")]: {
      marginLeft: 83,
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  analyticsSwitcher: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: 8,
    marginBottom: 12,
    "& .MuiButtonGroup-grouped:not(:last-of-type)": {
      borderRightColor: "#FE5A97",
    },
  },
  analyticsTab: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "14px",
    boxShadow: "none",
    "&.MuiButton-contained": {
      backgroundColor: "#FE5A97",
      borderColor: "#FE5A97",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#e54d88",
        borderColor: "#e54d88",
        boxShadow: "none",
      },
    },
    "&.MuiButton-outlined": {
      color: "#FFFFFF",
      borderColor: "#FE5A97",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "rgba(254, 90, 151, 0.08)",
        borderColor: "#FE5A97",
      },
    },
  },
  containerr: {
    padding: "20px 0 25px 0",
    [theme.breakpoints.down("md")]: {
      padding: "20px 0 25px 0",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 0 3px 0",
    },
  },
  welcome: {
    fontSize: "32px",
    fontWeight: 700,
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  subtitle: {
    fontSize: "20px",
    fontWeight: 400,
    color: "#FFFFFFCC",
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  balanceContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "16px",
    backgroundColor: "transparent",
    padding: 0,
    marginBottom: "30px",
    maxWidth: "100%",
  },
  balanceContainerDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  balanceTitle: {
    fontSize: "16px",
    lineHeight: 1.25,
    color: "#FFFFFF",
    fontWeight: 500,
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  balanceAmount: {
    fontSize: "32px",
    lineHeight: 1.1,
    fontWeight: 500,
    color: "#FFFFFF",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  balanceActions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  transactionsHistoryButton: {
    color: "#FFFFFF",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "none",
    padding: "16px 32px",
    borderRadius: "8px",
    whiteSpace: "nowrap",
    "&.MuiButton-outlined": {
      border: "1px solid #FE5A97",
    },
    "&:hover": {
      backgroundColor: "rgba(254, 90, 151, 0.08)",
      borderColor: "#FE5A97",
    },
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      minWidth: 0,
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      padding: "8px 16px",
    },
  },
  withdrawButton: {
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "none",
    padding: "16px 32px",
    borderRadius: "8px",
    whiteSpace: "nowrap",
    boxShadow: "none",
    "&.MuiButton-contained": {
      backgroundColor: "#FE5A97",
    },
    "&:hover": {
      backgroundColor: "#e54d88",
      boxShadow: "none",
    },
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      minWidth: 0,
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      padding: "8px 16px",
    },
  },
  monthlyEarningsGrid: {
    marginBottom: "30px",
    display: "flex",
    flexDirection: "column",
    maxWidth: "1250px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
    },
  },
  monthlyEarningsGridd: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: "24px",
    rowGap: "24px",
    justifyContent: "flex-start",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      columnGap: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      columnGap: "16px",
    },
  },
  monthlyEarningsGriddHelpp: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "20px",
    width: "100%",
    "& > *": {
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      gap: "12px",
    },
  },
  monthlyEarningsGridCard: {
    flex: "1 1 100%",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
  },
  monthlyEarningsGridTitle: {
    fontSize: "16px",
    color: "#FFFFFF",
    fontWeight: 600,
    marginBottom: "16px",
  },
  card: {
    display: "flex",
    columnGap: "24px",
    margin: "0",
  },
  statCard: {
    backgroundColor: "#131313",
    border: "1px solid #2F2F2F",
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.5)",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "175px",
    height: "auto",
    width: "100%",
    boxSizing: "border-box",
    minWidth: 0,
    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      padding: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
    },
  },
  statCardHelpc: {
    backgroundColor: "#131313",
    border: "1px solid #2F2F2F",
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.5)",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    minHeight: "250px",
    height: "auto",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      padding: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
    },
  },
  statCardCompact: {
    minHeight: "210px",
    height: "auto",
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#FFFFFF",
    marginBottom: "6px",
  },
  cardBottom: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    columnGap: "24px",
    rowGap: "12px",

    [theme.breakpoints.down("md")]: {
      columnGap: "16px",
    },
  },
  cardHelp: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 140px",
    minWidth: 0,
    marginTop: "16px",
  },
  cardValue: {
    fontSize: "36px",
    fontWeight: 600,
  },
  cardChange: {
    fontSize: "12px",
    color: "#FE5A97",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  divider: {
    backgroundColor: "#333",
    margin: "30px 0",
  },
  centre: {
    marginBottom: "30px",
    width: "100%",
    maxWidth: "100%",
  },
  centreLeft: {
    width: "100%",
    maxWidth: "100%",
  },
  centreRight: {
    width: "100%",
    maxWidth: "100%",
  },
  centreCard: {
    backgroundColor: "#131313",
    padding: "16px",
    color: "#fff",
    border: "1px solid #363636",
    height: "335px",
    borderRadius: "8px",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      height: "300px",
      padding: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "280px",
      maxWidth: "100%",
      padding: "10px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "250px",
      padding: "8px",
    },
  },
  centreCardBot: {
    backgroundColor: "#131313",
    padding: "16px",
    color: "#fff",
    border: "1px solid #363636",
    height: "335px",
    borderRadius: "8px",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      height: "300px",
      padding: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "280px",
      padding: "10px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "250px",
      padding: "8px",
    },
  },
  centreCardHelp: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "16px",
    },
  },
  cardHelpTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  dateRange: {
    fontSize: "12px",
    color: "#808080",
  },
  doughnutContainer: {
    position: "relative",
    width: "300px",
    height: "200px",
    margin: "auto",
    [theme.breakpoints.down("md")]: {
      width: "250px",
      height: "180px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "200px",
      height: "160px",
      maxWidth: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "180px",
      height: "140px",
    },
  },
  doughnutCenterText: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: "24px",
    fontWeight: 700,
    color: "#FFFFFF",
    textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)", // Тінь для тексту
    backgroundColor: "rgba(0, 0, 0, 0.7)", // Темний фон для центру
    padding: "5px 10px", // Відступи навколо тексту
    borderRadius: "5px", // Скруглення кутів
  },
  legend: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  legendColor: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },
  legendValue: {
    marginLeft: "auto",
    fontWeight: 600,
  },
  barChartLabels: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  barChartLabel: {
    fontSize: "12px",
    color: "#808080",
  },
  lineChart: {
    "& canvas": {
      borderRadius: "5px",
      backgroundColor: "rgba(255, 255, 255, 0.05)", // Легкий білий фон для лінійного графіка
      border: "1px solid #363636",
    },
  },
  doughnutChart: {
    "& canvas": {
      borderRadius: "50%", // Кругла форма для doughnut
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", // Тінь для ефекту
      width: "100%",
    },
  },
  barChart: {
    "& canvas": {
      borderRadius: "5px",
      backgroundColor: "rgba(19, 19, 19, 0.8)", // Темніший фон для bar chart
      border: "1px solid #363636",
      padding: "5px",
      width: "100%",
    },
  },
  subscribersBox: {
    backgroundColor: "#131313",
    padding: "16px",
  },
  subscribersBoxx: {
    backgroundColor: "#131313",
    padding: "16px",
    height: "465px",
    [theme.breakpoints.down("sm")]: {
      height: "auto", // Remove fixed height on mobile, let content determine height
      maxHeight: "465",
    },
  },
  earningsBox: {
    backgroundColor: "#131313",
    padding: "16px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#FFFFFF",
    marginBottom: "16px",
    display: "flex",
    justifyContent: "center",
  },
  subscriberItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #333",
  },
  earningItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid #333",
  },
  avatar: {
    marginRight: "10px",
  },
  likes: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
  },
  earnings: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
  },
  fotter: {
    display: "flex",
    border: "1px solid #363636",
    maxWidth: "1250px",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  fotterLeft: {
    width: "50%",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  fotterRight: {
    width: "50%",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  subscriberItemm: {
    display: "flex",
  },
  name: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#FFFFFF",
  },
  username: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#FFFFFF",
  },
  subscriberItemBot: {
    display: "flex",
    marginTop: "10px",
    justifyContent: "flex-end",
    fontSize: "14px",
    fontWeight: 600,
    color: "#FE5A97",
  },
  filterAdmin: {
    display: "grid",
    gridTemplateColumns: "repeat(6, minmax(120px, 1fr))",
    gap: 12,
    marginTop: 16,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "none",
    },
  },
  filterAdminHelp: {
    display: "grid",
    gridTemplateColumns: "repeat(6, minmax(120px, 1fr))",
    gap: 12,
    marginTop: 16,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "none",
    },
  },
  applyFilterButton: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "14px",
    height: 40,
    alignSelf: "end",
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#e54d88",
      boxShadow: "none",
    },
  },
  filterField: {
    /* текст у полі */
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    /* текст, що відображається у select */
    "& .MuiSelect-root": {
      color: "#fff",
    },
    /* колір лейбла */
    "& .MuiFormLabel-root": {
      color: "#bdbdbd",
    },
    /* лейбл у focus */
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#fff",
    },
    /* стрілочка у select */
    "& .MuiSelect-icon": {
      color: "#fff",
    },
    /* (опціонально) бордери outlined */
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#8c8c8c",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#bfbfbf",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
  },

  menuItem: {
    color: "#fff", // текст у випадаючому меню
  },
  butTimee: {
    backgroundColor: "#9d9b9b",
    color: "white",
  },
  butTime: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "14px",
    boxShadow: "none",

    "&.MuiButton-contained": {
      backgroundColor: "#FE5A97",
      borderColor: "#FE5A97",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#e54d88",
        borderColor: "#e54d88",
        boxShadow: "none",
      },
    },

    "&.MuiButton-outlined": {
      color: "#FFFFFF",
      borderColor: "#FE5A97",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "rgba(254, 90, 151, 0.08)",
        borderColor: "#FE5A97",
      },
    },
  },
  butTimeGroup: {
    boxShadow: "none",
    "& .MuiButtonGroup-grouped:not(:last-of-type)": {
      borderRightColor: "#FE5A97",
    },
  },
}));
